import React from 'react'
import gsap from 'gsap'
import { Tween, SplitChars } from 'react-gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function TittleWithAnimation ({word,_trigger, _start, _end, _scrub, _className})  {

    const multi_words = word.split(" ");

    return (
        <div className={`TittleSplitChars ${_className ? _className : ''}`} >
            {
                multi_words.map((item, index) => (
                    <div key={index}>
                        <Tween
                            to={{ 
                                scrollTrigger: {
                                    trigger: _trigger, 
                                    start: _start ? _start : '-180px center' ,
                                    end: _end && _end ,
                                    scrub: _scrub ? +_scrub : false
                                },
                                css : {
                                    x: '0',
                                    opacity: 1
                                }
                            }} 
                            stagger={0.1}
                        >
                            <SplitChars
                                wrapper={<span style={{ display: 'inline-block' }}/>}
                            >
                                {item}
                            </SplitChars>
                        </Tween>
                    </div>
                ))
            }
        </div>
    )
}

export default TittleWithAnimation




/*
Demo

<TittleWithAnimation
    word="Our" // (required)
    _trigger="#our-state" // (required)
    _start= '120px top',
    _scrub = true/false/.5
    _className = 'any'
/>

or

<TittleWithAnimation
    word="Our"
    _trigger="#our-state"
/>

_start= 'top/center/bottom/Npx top/center/bottom/Npx' 
*/